export const NAMESPACE = "SubmitFormModal";

export const SORTING = {
  POPULAR: "Popular",
  AZ: "A-Z"
};
